import React, { Component } from 'react'
import { connect } from 'react-redux'
import StaticBox from '../containers/StaticBox'
import Filter from '../misc/Filter'
import FlowTable from './FlowTable'
import Select from 'react-select'
import API from 'API'
import UUID from 'uuid/v4'
class SortableTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      loading: false,
      count: this.props.count || 20,
      totalResults: 0,
      activePage: 1,
      filter: '',
      sortingOrder: 'ASC',
      sortingValue: this.props.sortingKey,
      conditions: null,
      ready: false
    }

    if (!this.props.deepstream) return
    this.driver = this.props.deepstream.record.getRecord(`users/${this.props.user.id}/filter/${this.props.navigation.path}`)
  }
  async componentDidMount () {
    await this.setState({filters: (this.props.filters ? this.props.filters : null)})
    this.driver.whenReady(record => {
      let sorting = record.get('tableSorting')
      if (sorting && sorting.order && sorting.key) {
        return this.setState({...this.state, sortingValue: sorting.key, sortingOrder: sorting.order, ready: true}, e => { if (!this.props.filters) this.getData() })
      }
      this.setState({ready: true}, e => { if (!this.props.filters) this.getData() })
    })
  }

  onPageChange (e) {
    this.setState({activePage: e}, this.getData)
  }

  async getData () {
    this.setState({loading: true})
    var result = await API.list(this.props.endpoint, {
      objectid: (this.props.objectid ? this.props.objectid : null),
      data: (this.props.data ? this.props.data : {}),
      parameters: Object.assign(
        {},
        {
          pagination: true,
          'pagination.size': this.state.count,
          'pagination.from': (this.state.count * (this.state.activePage - 1))
        },
        this.props.filterKey && !this.props.filters && this.state.filter ? {
          'condition': true,
          'condition.values': {
            'items': [{
              'key': this.props.filterKey,
              'value': this.state.filter,
              'operator': 'CONTAINS'
            }]
          }
        } : {},
        this.props.filters && {
          'condition': !!this.state.conditions,
          'condition.values': this.state.conditions
        },
        {
          'sorting': true,
          'sorting.by': this.state.sortingValue,
          'sorting.order': this.state.sortingOrder
        }
    )})
    this.setState({loading: false, data: result.data ? result.data : [], totalResults: result.count})
  }
  filterTimeout () {
    this.setState({loading: true})
    clearTimeout(this.state.timer)
    this.state.timer = setTimeout(() => this.getData(), 300)
  }
  sortBy (column) {
    let sortingOrder = this.state.sortingOrder
    if (column === this.state.sortingValue) {
      sortingOrder = (this.state.sortingOrder === 'DESC' ? 'ASC' : 'DESC')
      this.driver.set('tableSorting', {key: column, order: sortingOrder})
      return this.setState({activePage: 1, sortingOrder: sortingOrder}, this.getData)
    }
    this.driver.set('tableSorting', {key: column, order: sortingOrder})
    this.setState({sortingValue: column, activePage: 1}, this.getData)
  }
  render () {
    if (!this.state.ready) return null
    return (
      <div>
        {this.state.filters && <Filter callback={conditions => this.setState({conditions: conditions, activePage: 1}, this.getData)} filters={this.state.filters} />}
        <StaticBox
          badges={[{value: this.state.totalResults}]}
          cols='12'
          icon={this.props.icon}
          title={this.props.title}
          filter={this.props.filterKey && !this.props.filters ? e => this.setState({filter: e.target.value, activePage: 1}, this.filterTimeout) : false}
          buttons={this.props.buttons}>
          <FlowTable className='count-table' loading={this.state.loading} data={this.state.data.map(data => this.props.format(data))} totalResults={this.state.totalResults} activePage={this.state.activePage} count={this.state.count} onPageChange={e => this.onPageChange(e)}>
            <tr>
              {this.props.columns.map(column =>
                <th key={UUID()} onClick={e => {
                  if (!column.sortable) return false
                  this.sortBy(column.value)
                }} className={(column.buttons ? 'buttons ' : '') + (column.sortable ? 'clickable' : '')}>{column.title || ''} {this.state.sortingValue === column.value && (this.state.sortingOrder === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)}</th>
              )}
            </tr>
          </FlowTable>
          <div className='row'>
            <Select
              className='table-pagination-select'
              searchable={false}
              labelKey='value'
              valueKey='value'
              clearable={false}
              value={this.state.count}
              options={[{value: 5}, {value: 10}, {value: 20}, {value: 30}, {value: 50}, {value: 100}]}
              onChange={(num) => this.setState({count: num.value}, this.getData)}
            />
          </div>
        </StaticBox>
      </div>
    )
  }
}
// eslint-disable-next-line
SortableTable = connect(state => state.siteReducer)(SortableTable)
export default SortableTable



// WEBPACK FOOTER //
// ./src/components/basic/tables/SortableTable.js